/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 12:06 PM
 *
 */

import Sidebar from 'components/layout/Sidebar/Sidebar';

export default Sidebar;
